const en = {
  nav: {
    home: 'MixGenie home',
    appNav: 'App navigation',
    signIn: 'Sign in',
    signUp: 'Sign up',
    install: 'Install',
    micAttached: 'Recording attached as reference',
  },
  common: {
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
  },
  settings: {
    title: 'Settings',
    theme: 'Theme',
    themeAuto: 'Auto',
    themeLight: 'Light',
    themeDark: 'Dark',
    language: 'Language',
    tutorial: 'Tutorial',
    tutorialCta: 'Show me around',
    tutorialToastTitle: 'Guided tour',
    tutorialToastBody: 'The walkthrough ships in the next release — in the meantime, drop a Reference, pick a Preset, and hit the ↑ button.',
    buildLabel: 'Build',
    iconsCredit: 'Icons: Solar by 480 Design, licensed CC BY 4.0',
    linkSupport: 'Support',
    linkPrivacy: 'Privacy Policy',
    linkTerms: 'Terms',
    linkRefund: 'Refund Policy',
  },
  languages: {
    en: 'English',
    es: 'Spanish',
    pt: 'Portuguese',
  },
  footer: {
    about: 'About',
    contact: 'Contact',
    help: 'Help center ↗',
    terms: 'Terms & Conditions',
    privacy: 'Privacy & Cookies',
  },
  composer: {
    emptyTitle: 'Create a song',
    emptySub: 'Start with an idea, a reference, or a preset.',
    typeIdea: 'Type an idea',
    uploadReference: 'Upload reference',
    pickPreset: 'Pick a preset',
    mySongs: 'My songs',
    orType: "or just type below — it's fine to start with nothing.",
    composingTitle: 'Composing your song…',
    composingSub: 'Lyrics · vocals · arrangement · cover art. Usually 2–4 min.',
    describePlaceholder: 'Describe your song — e.g. "melancholic indie pop about a rainy Sunday morning"',
    lyricsPlaceholder: 'Paste your lyrics here (optional). Leave blank to have MixGenie write them.',
    reference: 'Reference',
    presets: 'Presets',
    lyricsOff: '+ Lyrics',
    lyricsOn: 'Lyrics',
    instrumental: 'Instrumental',
    generating: 'Generating…',
    pricePerSong: '1 credit per song',
    signInFree: 'Sign in · 2 free',
    generateAria: 'Generate',
    draftLyrics: 'Draft lyrics from prompt',
    drafting: 'Drafting…',
  },
  generator: {
    title: 'Create your song',
    workingAria: 'Generating your song',
    cancel: 'Cancel',
    refSearchPlaceholder: 'Search a song to base yours on…',
    refSearchEmpty: 'No matches. Try a different title or artist.',
    refSearchExternal: 'From Genius / iTunes — imported on pick',
    imageTooLarge: 'Image too large (max 12 MB)',
    inspireDone: 'Song brief drafted from image',
    inspireFail: 'Could not interpret the image',
    inspireBusy: 'Reading the image…',
    inspireCtaShort: 'Draft a song from a photo',
    inspireReading: 'MixGenie sees',
    referenceAttached: 'Reference attached',
    referenceLabel: 'Reference song',
    referenceHintShort: 'Optional — search, pick, or record a track to base yours on.',
    referenceUsingLocal: 'Using your file as the audio seed',
    pickDeviceFile: 'Pick from device',
    recordMic: 'Record with mic',
    micAttached: 'Recording attached as reference',
    untitled: 'MixGenie song',
    generateAnother: 'Generate another',
    working: 'Generating…',
    needBase: 'Add a prompt or a reference',
    needLyrics: 'Add lyrics or tick Instrumental',
    needPromptOrReference: 'Add a prompt or a reference song to generate.',
    generate: 'Generate song',
    lyricsDraftEmpty: 'Could not draft lyrics — try adding a prompt or a theme.',
    lyricsDraftFailed: 'Draft failed',
    tooFast: 'Whoa — hold on a couple of seconds before generating again.',
    failed: 'Generation failed. Please try again.',
    newBrief: 'New',
    promptLabel: 'Prompt',
    addSoundPreset: 'Add style / instrument',
    promptPlaceholder: 'e.g. Dark synth-wave with driving bass, cinematic feel, 2020s production',
    lyricsLabel: 'Lyrics',
    addLyricTheme: 'Add lyric theme',
    lyricsLanguageLabel: 'Language',
    draftLyrics: 'Draft lyrics',
    instrumental: 'Instrumental only',
    instrumentalOn: 'Instrumental selected — lyrics disabled.',
    lyricsPlaceholder: 'Write or paste your lyrics here. Click ✨ Draft lyrics to have MixGenie propose some.',
    jobFailed: 'Generation failed',
    done: 'Done',
    viewAll: 'My songs',
    nowPlaying: '🎵 Playing in the bottom player — use it to pause, seek and control volume.',
    download: 'Download',
    withCoverShort: '+ Cover art',
    paywallTitle: "You're out of credits",
    paywallBody: 'Grab a credit pack or subscribe to keep generating.',
    pw1: 'Unlimited song generation',
    pw2: 'Priority queue',
    pw3: 'HD downloads',
    seePlans: 'See plans',
    queueFullTitle: 'You already have songs in the queue',
    queueFullBody: 'Free plans can have {{limit}} generations in flight at a time. Wait for one to finish — or upgrade to run more in parallel.',
    queueFullBodyGeneric: 'Wait for one to finish — or upgrade to run more in parallel.',
    qf1: 'Skip the free-tier queue',
    qf2: 'Run multiple generations in parallel',
    qf3: 'Priority processing',
    queueFullWait: "I'll wait",
    queueFullUpgrade: 'Upgrade',
  },
  genOverlay: {
    push: {
      done: "We'll ping you the second it's ready ✓",
      prompt: 'Want a ping when it finishes?',
      yes: 'Yes',
      no: 'No thanks',
    },
  },
  credits: {
    checkoutSuccess: 'Payment received — your credits are updating.',
    checkoutCancelled: 'Checkout cancelled.',
  },
  history: {
    title: 'My songs',
    untitled: 'Untitled',
    loadError: 'Failed to load your songs.',
    empty: "You haven't created any songs yet.",
    emptyPlaylist: 'This playlist is empty. Add songs from All songs.',
    emptyCta: 'Create your first song',
    playlistCreated: 'Playlist created — song added',
    playlistCreateFail: 'Could not create playlist',
    favFail: 'Could not update — try again',
    linkCopied: 'Share link copied',
    downloadFailed: 'Download failed',
    lyricsCopied: 'Lyrics copied',
    lyricsCopyFail: 'Copy failed — select the text manually',
    failedArt: 'This job has failed',
    unavailable: 'Unavailable',
    processing: 'Generating…',
    share: 'Share',
    rename: 'Rename',
    viewLyrics: 'View lyrics',
    generateSimilar: 'Generate similar',
    openStudio: 'Open in Studio',
    download: 'Download',
    playlists: 'Playlists',
    newPlaylistFromSong: 'New playlist with this song',
    noPlaylists: 'No other playlists yet.',
    confirmDelete: 'Delete "{{title}}"? This removes the song and its audio permanently.',
    deleted: 'Song deleted',
    delete: 'Delete song',
    renameTitle: 'Rename song',
    renameLabel: 'Song title',
    lyricsFor: 'Lyrics',
    copyLyrics: 'Copy',
    newSongWithLyrics: 'New song with these lyrics',
    playlistNameLabel: 'Playlist name',
    playlistNamePlaceholder: 'e.g. Chill vibes',
    playlistCreateAndAdd: 'Create & add',
  },
  player: {
    coverDone: 'Cover generated — updating…',
    coverFail: 'Cover generation failed — try again',
    coverTooLarge: 'Image too large (max 12 MB)',
    coverUploaded: 'Cover updated',
    coverUploadFail: 'Upload failed — try again',
    coverPainting: 'Painting cover with pictools.ai…',
    coverCta: 'Generate cover with pictools.ai',
    coverCost: '1 credit',
    coverUploading: 'Uploading cover…',
    coverUploadCta: 'Upload from device / camera',
    linkCopied: 'Share link copied',
    confirmDelete: 'Delete "{{title}}"? This removes the song permanently.',
    deleted: 'Song deleted',
    menuShare: 'Share',
    menuDownload: 'Download',
    menuRename: 'Rename',
    menuGenerateSimilar: 'Generate similar',
    menuMakeVideo: 'Make video',
    menuDelete: 'Delete',
    renameTitle: 'Rename song',
    renameLabel: 'Song title',
  },
  userMenu: {
    signedInAs: 'Signed in as',
    anonymous: 'User',
    mySongs: 'My songs',
    library: 'Music library',
    credits: 'Credits',
    themeLight: 'Light theme',
    themeDark: 'Dark theme',
    help: 'Help & support ↗',
    signOut: 'Sign out',
  },
  push: {
    label: 'Notifications',
    title: 'Ping me when a song is ready',
    blocked: 'Notifications are blocked in your browser settings for this site. Enable them in the address bar (padlock icon) → Permissions.',
    subscribed: "You're subscribed on this device. Turn off to stop.",
    pitch: 'Get a notification the moment your song finishes generating — no need to keep the tab open.',
    toggle: 'Toggle notifications',
    openSettings: 'Open browser notification settings',
  },
  invite: {
    title: 'Invite friends, earn credits',
    subtitle: 'You both get {{r}} credits when they sign up{{p}}.',
    subtitlePurchase: ' — plus {{n}} more when they buy their first pack',
    subtitleReferrerOnly: 'Get {{n}} credits every time a friend signs up with your link.',
    shareTitle: 'Make songs with MixGenie',
    shareText: 'Join me on MixGenie — we both get {{n}} free song credits.',
    shareTextNoBonus: 'Join me on MixGenie — free song generator.',
    copied: 'Invite link copied',
    copyFailed: "Couldn't copy — long-press the link to share manually",
    codeCopied: 'Code copied',
    copyCode: 'Copy code',
    linkCopied: 'Link copied ✓',
    share: 'Share your invite link',
    statsInvites: '{{n}} joined',
    statsEarned: 'earned',
  },
  video: {
    eyebrow: 'Make video',
    formatLabel: 'Format',
    styleLabel: 'Background',
    styleRandom: 'Random',
    styleRandomHint: 'A different look each time you render — great for shipping variants without deciding.',
    watermark: 'Show mixgenie.ai watermark',
    karaoke: 'Karaoke lyrics (estimated sync)',
    karaokeHint: 'Line timing is estimated from the song length — expect to be within a beat or two.',
    karaokeSynced: 'Karaoke lyrics (word-accurate)',
    karaokeSyncedHint: 'Word timing from the provider — hits every syllable.',
    karaokeNoLyrics: 'This song has no lyrics on file.',
    rendering: 'Rendering in real time — the song will play through once.',
    ready: 'Video is ready — tap Download to save.',
    cancel: 'Stop',
    render: 'Render video',
    renderAgain: 'Render again',
    download: 'Download',
    coverFailed: 'Could not load the cover — rendering without it.',
  },
};

export default en;
export type Resources = typeof en;
